import getServerTime from 'modules-core/utility/serverTime'
import { createDefaultEffectParams } from './constants'
import { caveConvolverUrl, concertHallConvolverUrl, stairwellConvolverUrl } from './convolverUrls'
import { AudioEffect } from './types'



export const createDefaultEffectFile = (): AudioEffect.EffectFile => ({
	"effects": [
		{
			"name": "Alley ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/alley-ss.wav"
		},
		{
			"fftSize": 256,
			"isDestination": true,
			"maxDecibels": -30,
			"minDecibels": -100,
			"name": "Analyser",
			"smoothingTimeConstant": 0.8,
			"type": "analyser"
		},
		{
			"name": "Arena ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/arena-ss.wav"
		},
		{
			"name": "Auditorium ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/auditorium-ss.wav"
		},
		{
			"name": "Bathroom ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/bathroom-ss.wav"
		},
		{
			"name": "Carpetted Hallway ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/carpetted-hallway-ss.wav"
		},
		{
			"name": "Cave",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/cave.wav"
		},
		{
			"name": "Cave ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/cave-ss.wav"
		},
		{
			"name": "City ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/city-ss.wav"
		},
		{
			"attack": 0.003,
			"knee": 30,
			"name": "Compressor",
			"output": "Analyser",
			"ratio": 12,
			"release": 0.25,
			"threshold": -24,
			"type": "compressor"
		},
		{
			"name": "Concert Hall",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/concert-hall.wav"
		},
		{
			"name": "Concert Hall ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/concert-hall-ss.wav"
		},
		{
			"name": "Crazed ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/crazed-ss.wav"
		},
		{
			"name": "Dazed ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/dazed-ss.wav"
		},
		{
			"dryOutput": "Global Volume",
			"name": "Dry Long",
			"output": "Concert Hall",
			"type": "send",
			"wetness": 0.5
		},
		{
			"dryOutput": "Global Volume",
			"name": "Dry Short",
			"output": "Concert Hall",
			"type": "send",
			"wetness": 0.2
		},
		{
			"name": "Flooded Cavern ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/flooded-cavern-ss.wav"
		},
		{
			"name": "Forest ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/forest-ss.wav"
		},
		{
			"fadeDuration": 1,
			"name": "Global Volume",
			"output": "Local Volume",
			"type": "volume",
			"volume": 1
		},
		{
			"name": "Hallway ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/hallway-ss.wav"
		},
		{
			"name": "Hanger ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/hanger-ss.wav"
		},
		{
			"fadeDuration": 1,
			"name": "Local Volume",
			"output": "Compressor",
			"type": "volume",
			"volume": 1
		},
		{
			"dampening": 6000,
			"gain": 0.2,
			"hpFrequency": 600,
			"hpResonance": 0.5,
			"lpFrequency": 2000,
			"lpResonance": 0.5,
			"name": "Long Reverb",
			"output": "Global Volume",
			"preDelay": 0.01,
			"roomSize": 0.9,
			"type": "freeverb"
		},
		{
			"name": "Metal Room ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/metal-room-ss.wav"
		},
		{
			"name": "Mountains ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/mountains-ss.wav"
		},
		{
			"name": "Padded Cell ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/padded-cell-ss.wav"
		},
		{
			"name": "Parking lot ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/parking-lot-ss.wav"
		},
		{
			"name": "Plains ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/plains-ss.wav"
		},
		{
			"name": "Poisoned ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/poisoned-ss.wav"
		},
		{
			"name": "Quarry ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/quarry-ss.wav"
		},
		{
			"name": "Sewer pipe ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/sewer-pipe-ss.wav"
		},
		{
			"duration": 0.2,
			"falloff": 0.4,
			"name": "Simple Delay",
			"output": "Global Volume",
			"type": "delay"
		},
		{
			"name": "Soft furnished room ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/soft-furnished-room-ss.wav"
		},
		{
			"name": "Stairwell",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/stairwell.wav"
		},
		{
			"name": "Stone Corridor ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/stone-corridor-ss.wav"
		},
		{
			"name": "Stone Dungeon ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/stone-dungeon-ss.wav"
		},
		{
			"name": "Stone room ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/stone-room-ss.wav"
		},
		{
			"name": "Through a heavy door ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/through-a-heavy-door-ss.wav"
		},
		{
			"name": "Through a light door ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/through-a-light-door-ss.wav"
		},
		{
			"name": "Underwater ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/underwater-ss.wav"
		},
		{
			"name": "Vanilla room ss",
			"output": "Global Volume",
			"type": "convolver",
			"url": "https://storage.syrinscape.com/media/convolvers/vanilla-room-ss.wav"
		},
		{
			"dryOutput": "Global Volume",
			"name": "Wet Effect",
			"output": "Simple Delay",
			"type": "send",
			"wetness": 0.7
		},
		{
			"dryOutput": "Global Volume",
			"name": "Wet Long",
			"output": "Long Reverb",
			"type": "send",
			"wetness": 1
		},
		{
			"dryOutput": "Global Volume",
			"name": "Wet Short",
			"output": "Stairwell",
			"type": "send",
			"wetness": 0.75
		}
	],
	"presets": {
		"Alley": {
			"dryGain": 2,
			"drySpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 30,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 1,
				"speed": 0,
				"type": "spatial"
			},
			"effect": "Alley ss",
			"name": "Alley",
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 50,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.5,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Arena": {
			"dryGain": 1,
			"drySpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 1,
				"speed": 0,
				"type": "spatial"
			},
			"effect": "Arena ss",
			"name": "Arena",
			"wetGain": 0.1,
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.4,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Auditorium": {
			"dryGain": 1,
			"effect": "Auditorium ss",
			"name": "Auditorium",
			"wetGain": 0.1
		},
		"Bathroom": {
			"effect": "Bathroom ss",
			"name": "Bathroom"
		},
		"Carpetted Hallway": {
			"dryGain": 1,
			"effect": "Carpetted Hallway ss",
			"name": "Carpetted Hallway",
			"wetGain": 0.4
		},
		"Cave": {
			"effect": "Cave",
			"name": "Cave"
		},
		"City": {
			"effect": "City ss",
			"name": "City"
		},
		"Concert Hall": {
			"dryGain": 0.5,
			"effect": "Concert Hall ss",
			"name": "Concert Hall",
			"wetGain": 1
		},
		"Crazed": {
			"dryGain": 1,
			"effect": "Crazed ss",
			"name": "Crazed",
			"wetGain": 0.3
		},
		"Dazed": {
			"dryGain": 1,
			"effect": "Dazed ss",
			"name": "Dazed",
			"wetGain": 0.1
		},
		"Default": {
			"dryGain": 1,
			"drySpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "My spatial effect 2",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 1,
				"speed": 0,
				"type": "spatial"
			},
			"effect": "Global Volume",
			"isFixed": true,
			"name": "Default",
			"wetGain": 1,
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "My spatial effect 1",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.4,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Flooded Cavern": {
			"dryGain": 1,
			"effect": "Flooded Cavern ss",
			"name": "Flooded Cavern",
			"wetGain": 0.5
		},
		"Forest": {
			"effect": "Forest ss",
			"name": "Forest"
		},
		"Hallway": {
			"effect": "Hallway ss",
			"name": "Hallway"
		},
		"Hangar": {
			"dryGain": 1,
			"effect": "Hanger ss",
			"name": "Hangar",
			"wetGain": 0.15,
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.8,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Metal Room": {
			"effect": "Metal Room ss",
			"name": "Metal Room"
		},
		"Mountains": {
			"effect": "Mountains ss",
			"name": "Mountains",
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.8,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Off": {
			"effect": "Global Volume",
			"name": "Off"
		},
		"Padded Cell": {
			"dryGain": 1,
			"effect": "Padded Cell ss",
			"name": "Padded Cell",
			"wetGain": 0.2
		},
		"Parking lot": {
			"dryGain": 1,
			"effect": "Parking lot ss",
			"name": "Parking lot",
			"wetGain": 0.3
		},
		"Plain": {
			"effect": "Plains ss",
			"name": "Plain"
		},
		"Poisoned": {
			"dryGain": 1,
			"effect": "Poisoned ss",
			"name": "Poisoned",
			"wetGain": 0.5,
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.5,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Quarry": {
			"effect": "Quarry ss",
			"name": "Quarry"
		},
		"Sewer pipe": {
			"effect": "Sewer pipe ss",
			"name": "Sewer pipe"
		},
		"Soft furnished room": {
			"effect": "Soft furnished room ss",
			"name": "Soft furnished room"
		},
		"Stone Corridor": {
			"dryGain": 1,
			"effect": "Stone Corridor ss",
			"name": "Stone Corridor",
			"wetGain": 0.3
		},
		"Stone Dungeon": {
			"effect": "Stone Dungeon ss",
			"name": "Stone Dungeon",
			"wetGain": 6.33
		},
		"Stone room": {
			"dryGain": 1,
			"effect": "Stone room ss",
			"name": "Stone room",
			"wetGain": 0.4
		},
		"Through a heavy door": {
			"dryGain": 0,
			"effect": "Through a heavy door ss",
			"name": "Through a heavy door",
			"wetGain": 0.5,
			"wetSpatializer": {
				"distanceModel": "exponential",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.7,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Through a light door": {
			"dryGain": 0.1,
			"effect": "Through a light door ss",
			"name": "Through a light door",
			"wetGain": 0.47,
			"wetSpatializer": {
				"distanceModel": "inverse",
				"maxDistance": 100,
				"minDistance": 1,
				"name": "Wet Spatializer",
				"output": "Global Volume",
				"panningModel": "HRTF",
				"position": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"rolloff": 0.7,
				"speed": 0,
				"type": "spatial"
			}
		},
		"Underwater": {
			"dryGain": 1,
			"effect": "Underwater ss",
			"name": "Underwater",
			"wetGain": 0.3
		},
		"Vanilla room": {
			"dryGain": 1,
			"effect": "Vanilla room ss",
			"name": "Vanilla room",
			"wetGain": 0.5
		}
	},
	"timestamp": 1672719228481.26
})
